import { DigitalTwinTranslations } from 'api/digitalTwin/digitalTwin.api'

import _ChartJS from 'chart.js/auto'
import { type DatasetFillMethod } from 'helpers/dataset.helper/dataset.helper.types'
import { ReactNode } from 'react'
import { colors } from 'styles/variables'
import { DatasetTableProps } from '../DatasetTable/DatasetTable.types'

export type ChartJS = _ChartJS

export const chartColors = {
  tooltipBackground: colors.grey1,
  black: colors.black,
  crosshair: colors.crosshair,
  zoomBoxBackground: `rgba(66,133,244,0.2)`,
  zoomBoxBorder: colors.info4,
  gridLines: colors.grey4,
  greyedFont: colors.grey5,
  white: colors.white,
}

export type ChartItem = {
  title: string
  display_title?: string
  data_id: string
  color?: string
  unit?: string
  decimals?: number
  fill?: boolean | number | string
  dashed?: boolean
  y_axis_id?: string
  opacity?: boolean
  config?: Record<string, unknown>
  order?: number
  stack_group?: number
  data_type?: `power` | `energy` | `cost` | `cost/energy`
  tooltip_always_positive?: boolean
  tooltip_do_not_show_zero_values?: boolean
  tooltip_show_time_as_interval?: boolean
  tooltip_do_not_show_value?: boolean
  default_hidden?: boolean
  border_width?: number
  ignore_empty_filter?: boolean
  show_as_negative?: boolean
  h_energy_bar?: boolean
  tag?: string
  tags?: string[]
  show_only_in_export?: boolean
  show_only_in_chart?: boolean
  do_not_show_item?: boolean
  is_peak_unit?: boolean
  show_arrow_icon?: boolean
}

export type ChartJSDatasetConfig = {
  label: string
  data: Array<number | null>
  returnId?: string
  backgroundColor?: string
  borderColor?: string
  borderWidth?: number
  borderDash?: number[]
  decimals?: number
  unit?: string
  yAxisID?: string
  fill?: boolean | number | string
  order?: number
  stack?: number
  data_type?: string
  tooltip_always_positive?: boolean
  tooltip_do_not_show_zero_values?: boolean
  tooltip_show_time_as_interval?: boolean
  tooltip_do_not_show_value?: boolean
  hidden?: boolean
  border_width?: number
  hoverBackgroundColor?: string
  show_arrow_icon?: boolean
  spanGaps?: boolean
}

export type ChartConfigWithZoom = any

export type FilterItems = {
  data_ids: number[]
  return_ids: string[]
  include_only_base_items_with_attr?: Record<string, boolean | number | string | null>
  default_hidden?: true
  is_mutually_exclusive?: false
  title: string
}

export type ChartDatasetTableProps = { default: boolean; display: boolean } & Partial<DatasetTableProps>

export type ChartProps = {
  base_items?: { all: boolean }
  items: ChartItem[]
  config: ChartConfigWithZoom
  datasets: Dataset[]
  children?: ReactNode
  filter_items?: FilterItems[]
  title?: string
  uid?: number
  height?: number
  ignoreAggregate?: boolean
  dataset_table?: ChartDatasetTableProps
  translations?: { [key: string]: string }
  hide_legend?: boolean
  legendKey?: string
  maxWidth?: string
  digitalTwinTranslations?: DigitalTwinTranslations
  settingInfo?: { name: string; attribute: string }
  spanGaps?: boolean
  excel_fill_method?: DatasetFillMethod
}
